webpackJsonp([180824789067976],{

/***/ 406:
/***/ (function(module, exports) {

	module.exports = {"data":{"site":{"siteMetadata":{"title":"Write Code Everyday","subtitle":"I'm interested in React, GraphQL.","copyright":"© All rights reserved.","menu":[{"label":"Articles","path":"/"},{"label":"About me","path":"/about/"},{"label":"Contact me","path":"/contact/"}],"author":{"name":"Steve Han","email":"heeinso@snu.ac.kr","github":"/heeinso","rss":"#"}}},"allMarkdownRemark":{"edges":[{"node":{"fields":{"slug":"/posts/what-is-mandalart/","categorySlug":"/categories/react/"},"frontmatter":{"title":"만다라트(Mandalart) 기반 목표 달성 서비스 만들기","date":"2018-07-22T15:30:00.962Z","category":"React","description":"목표 달성 기술인 만다라트(Mandalart) 프로젝트를 시작합니다!"}}}]}},"pathContext":{"category":"React"}}

/***/ })

});


// WEBPACK FOOTER //
// path---categories-react-da953b6e6df67d4b4299.js